export default "float quarticIn(float t) {\n  return pow(t, 4.0);\n}\n\n"